import { Stack } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from '../../../../../../../../../translation/TranslationContext';
import { useSelloutTableConfig } from '../../../hooks/useSelloutTableConfig';
import SelloutDistributionRow from '../../distribution/components/SelloutDistributionRow';
import { SelloutModalContentProps } from '../../modal/types/selloutModalContent.types';
import SelloutRowMobile from './SelloutRowMobile';

interface SelloutModalContentMobileProps extends SelloutModalContentProps {}

const SelloutModalContentMobile = ({
  pieces,
  disabled,
  distribution,
  selloutProductColor,
  onChangePieces,
}: SelloutModalContentMobileProps) => {
  const { translate } = useTranslation();

  const { sortedSkuBySizePosition, tableRowsConfig } = useSelloutTableConfig({
    selloutProductColor,
  });

  return (
    <Stack spacing="24px">
      {tableRowsConfig.map((config) => (
        <SelloutRowMobile
          key={config.titleKey}
          data={config.data}
          total={config.total}
          subtitle={config.subtitle}
          title={translate(config.titleKey)}
        />
      ))}

      <SelloutDistributionRow
        pieces={pieces}
        disabled={disabled}
        distribution={distribution}
        selloutSkus={sortedSkuBySizePosition}
        onChangePieces={onChangePieces}
      />
    </Stack>
  );
};

export default memo(SelloutModalContentMobile);
